import DaoBase from "./base";

class DaoInformation extends DaoBase {
    addr;
    ceo_name;
    customer_tel;
    name;
    register_number;
    remote_url;
    service_name;

    constructor(json=null) {
        super(json);
    }
}

export default DaoInformation;


// WEBPACK FOOTER //
// ./src/modules/dao/information.js